import { Component, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR} from '@angular/forms';
@Component({
    selector: 'input-check',
    templateUrl: 'input-check.component.html',
    styleUrls: ['input-check.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputCheckComponent),
        multi: true
    }]
})
export class InputCheckComponent {
    check: any;
    @Input()
    available:boolean=false;
    @Input()
    value:number;
    @Input()
    element:any;
    @Input()
    name:string;
    @Input()
    theme:string;
    _onChange = (_: any) => { };
    _onTouched = () => { };

    writeValue(value: any): void {
        this.check = value;
        this._onChange(value);
    }

    registerOnChange(fn: (_: any) => {}): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: () => {}): void {
        this._onTouched = fn;
    }

    private getValues(): boolean {
        return this.check;
    }

    change(){
        this.writeValue(this.getValues());
    }
}
